import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type LoadingAnimationProps = {
    size?: number; // Optional prop to control the size of the SVG
    isHeight?:boolean;
};

export default function LoadingAnimation({ size = 150,isHeight }: LoadingAnimationProps) {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height:isHeight? '50vh':'100vh',
                width: '100%',
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width={`${size}px`} viewBox="0 0 200 200">
                {[0, 0.05, 0.1, 0.15, 0.2].map((begin, index) => (
                    <circle
                        key={index}
                        fill={primaryColor}
                        stroke={primaryColor}
                        strokeWidth="15"
                        opacity={1 - index * 0.2}
                        r="15"
                        cx="35"
                        cy="100"
                    >
                        <animate
                            attributeName="cx"
                            calcMode="spline"
                            dur="2"
                            values="35;165;165;35;35"
                            keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1"
                            repeatCount="indefinite"
                            begin={begin}
                        ></animate>
                    </circle>
                ))}
            </svg>
        </Box>
    );
}
